import React from "react";
import { Helmet } from "react-helmet";
import "../css/TermsConditions.css";

const TermsConditions = () => {
  return (
    <div>

      <Helmet>
        <title>Shreesha Tours & Travels | Terms & Conditions</title>

        <meta
          name="description"
          content="Terms & Conditions for Shreesha Tours & Travels including tour packages, travel services, taxi rental, holiday trips, and transportation services."
        />

        <meta
          name="keywords"
          content="Shreesha Tours & Travels, Tour Packages, Travel Services, Taxi Rental, Holiday Packages, Terms & Conditions"
        />
      </Helmet>

 <section className="page-banner">
      <div className="page-banner-container">
        <h2>
          Terms & Conditions
        </h2>
      </div>
    </section>

  




      <section className="terms-section">

        <div className="container">


          <div className="row g-0">


            <img 
              className="img-fluid" 
              src="/images/term.jpg" 
              alt="Terms and Conditions" 
            />



            <div className="col-md-12">


              <div className="terms-content">



                <p>
                  <b className="highlight">
                    1. Booking Confirmation:
                  </b>
                  <br />

                  All bookings with Shreesha Tours & Travels are subject
                  to availability. Booking confirmation will be provided
                  after receiving customer details and confirmation from
                  our team.
                </p>




                <p>
                  <b className="highlight">
                    2. Travel Service Usage:
                  </b>
                  <br />

                  Our services include tour packages, holiday trips,
                  taxi rentals, transportation services, and customized
                  travel solutions. Customers must follow travel rules
                  and avoid carrying illegal or hazardous materials.
                </p>




                <p>
                  <b className="highlight">
                    3. Payment Policy:
                  </b>
                  <br />

                  Customers can make payments through cash, UPI,
                  online payment, or bank transfer. Advance payment
                  may be required for tour packages, vehicle bookings,
                  and customized travel plans.
                </p>




                <p>
                  <b className="highlight">
                    4. Cancellation Policy:
                  </b>
                  <br />

                  Cancellation requests must be informed before the
                  scheduled travel date. Cancellation charges may apply
                  depending on the service type, booking date, and
                  cancellation timing.
                </p>




                <p>
                  <b className="highlight">
                    5. Customer Responsibility:
                  </b>
                  <br />

                  Customers must provide correct personal details,
                  travel requirements, pickup locations, and destination
                  information. Additional charges may apply due to
                  incorrect details or customer delays.
                </p>




                <p>
                  <b className="highlight">
                    6. Vehicle Capacity & Luggage:
                  </b>
                  <br />

                  Passengers must not exceed the permitted seating
                  capacity of the vehicle. Customers are responsible
                  for their personal belongings and luggage during
                  travel.
                </p>




                <p>
                  <b className="highlight">
                    7. Driver & Travel Guidelines:
                  </b>
                  <br />

                  Drivers follow safety regulations and transportation
                  guidelines. Additional driver charges may apply for
                  long-distance travel as per requirements.
                </p>




                <p>
                  <b className="highlight">
                    8. Safety Guidelines:
                  </b>
                  <br />

                  Customers must follow safety instructions, use seat
                  belts where available, and avoid damaging vehicles.
                  Any damage caused by passengers will be chargeable.
                </p>




                <p>
                  <b className="highlight">
                    9. Service Availability:
                  </b>
                  <br />

                  Shreesha Tours & Travels reserves the right to modify,
                  postpone, or refuse services due to safety concerns,
                  unavoidable circumstances, or violation of travel
                  policies.
                </p>




                <p>
                  <b className="highlight">
                    10. Jurisdiction:
                  </b>
                  <br />

                  Any disputes related to services provided by Shreesha
                  Tours & Travels shall be handled under the applicable
                  local jurisdiction.
                </p>




                <h3>
                  Travel & Rental Policy
                </h3>




                <p>
                  <b className="highlight">
                    Tour Packages & Transportation Services:
                  </b>
                  <br />

                  Shreesha Tours & Travels provides reliable travel
                  solutions including holiday packages, family trips,
                  corporate travel, sightseeing tours, taxi rental,
                  and customized travel plans.
                </p>




                <p>
                  <b className="highlight">
                    Toll, Parking & Additional Charges:
                  </b>
                  <br />

                  Toll charges, parking fees, interstate taxes, and
                  additional travel expenses will be paid by the customer
                  unless included in the selected package.
                </p>





                <h3>
                  Refund Policy
                </h3>




                <p>
                  <b className="highlight">
                    Refund Eligibility:
                  </b>
                  <br />

                  Refunds depend on cancellation timing, booking type,
                  service availability, and applicable cancellation
                  charges.
                </p>




                <p>
                  <b className="highlight">
                    Refund Processing:
                  </b>
                  <br />

                  Approved refunds will be processed within 5–7 working
                  days through the original payment method.
                </p>




                <p>
                  <b className="highlight">
                    No Show Policy:
                  </b>
                  <br />

                  No refund will be provided if customers fail to arrive
                  at the pickup location or cancel services at the last
                  moment.
                </p>



              </div>

            </div>

          </div>






          <div className="contact-info">


            <h2>
              Contact Us
            </h2>



            <p>
              For tour packages, taxi rental, holiday trips, and travel
              assistance, contact Shreesha Tours & Travels:
            </p>




            <ul>


              <li>
                <b>Mobile:</b>{" "}

                <a href="tel:+918355835813">
                  +91 83558 35813
                </a>

                {" / "}

                <a href="tel:+919930929439">
                  +91 99309 29439
                </a>

                {" / "}

                <a href="tel:+919022432779">
                  +91 90224 32779
                </a>

              </li>





              <li>
                <b>Email:</b>{" "}

                <a href="mailto:booking@shreeshatravels.com">
                  booking@shreeshatravels.com
                </a>

              </li>





              <li>

                <b className="darkcolorrr">
                  Address:
                </b>


                <br />


                <h6>
                  Shreesha Tours & Travels
                </h6>


                Office 125, Saishraddha CHS,<br />
                Plot No 47, Near Koparkhairane Police Station,<br />
                Sector 5, Sector 4, Ghansoli,<br />
                Navi Mumbai, Maharashtra, India - 400701.


              </li>


            </ul>


          </div>


        </div>

      </section>


    </div>
  );
};


export default TermsConditions;